<template>
  <div class="py-4 container-fluid">
    <a class="btn btn-sm btn-primary" style="margin-right: 10px;" :href="apiUrl+'export-excel/project-list?project_number='+search.project_number+'&project_name='+search.project_name+'&category='+search.category+'&equipment='+search.equipment['equipment_number']+'&customer='+search.customer['name']+'&cust_po_number='+search.cust_po_number+'&po_date='+search.po_date+'&customer_req_date='+search.customer_req_date+'&delivery_date='+search.delivery_date+'&status='+search.status+''" target="_BLANK"><i class="fa fa-download fa-sm"></i> Export</a>
    <!-- <argon-button color="warning" size="sm" class="mb-3" variant="gradient" @click="modalImport()"><i class="fa fa-upload fa-sm"></i> Import</argon-button> -->
    <div class="row">
      <div class="col-lg-3 col-md-3 col-12">
        <card
          title="Fabrication Project"
          :value="(totalFabProject)"
          iconClass="fa fa-gavel"
          iconBackground="bg-gradient-info"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-3 col-12">
        <card
          title="Service Project"
          :value="(totalServcProject)"
          iconClass="fa fa-cog"
          iconBackground="bg-gradient-primary"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-3 col-12">
        <card
          title="Active Project"
          :value="(totalActiveProject)"
          iconClass="fa fa-calendar-times-o"
          iconBackground="bg-gradient-warning"
          directionReverse
        ></card>
      </div>
      <div class="col-lg-3 col-md-3 col-12">
        <card
          title="Inactive Project"
          :value="(totalInactiveProject)"
          iconClass="fa fa-check-circle"
          iconBackground="bg-gradient-success"
          directionReverse
        ></card>
      </div>
    </div>
    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-4">
                <div class="card-header pb-0">
                  <h6>Project List</h6>
                </div>
              </div>
              <div class="col-4">
              </div>
              <div class="col-4 float-right">
                <argon-button
                  style="margin-right: 10px; margin-left: 60px;"
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="create()"
                ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add New</argon-button>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class=" table-hover table-striped table-bordered align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="width:30px;">No</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="width:500px;">Project</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="width:350px;">Customer</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="width:70px;">Category</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="width:240px;">Description</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="width:230px;">Date</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="width:60px;">Status</th>
                      <th class="text-center text-uppercase text-white text-xxs font-weight-bolder" style="width:70px;">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in table.data" :key="i" style="border-bottom: 1pt solid #DCDCDC; padding: 5px;">
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ i + 1 }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold"><span class="font-weight-bold text-dark">NUMBER &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; </span>  {{ row.project_number }} </span><br>
                        <span class="text-secondary text-xs font-weight-bold"><span class="font-weight-bold text-dark">NAME &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; </span>  {{ row.project_name }} </span><br>
                        <span class="text-secondary text-xs font-weight-bold"><span class="font-weight-bold text-dark">EQUIPMENT &nbsp; :&nbsp; </span>  {{ row.equipment_number }} - {{ row.equipment_name }} </span><br>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-dark text-xs font-weight-bold"> {{ row.customer_name }} </span><br> 
                        <span class="text-secondary text-xs font-weight-bold"><span class="font-weight-bold text-dark">PO NUMBER &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; </span>  {{ row.project_number }} </span><br>
                        <span class="text-secondary text-xs font-weight-bold"><span class="font-weight-bold text-dark">SHIP LOCATION &nbsp;&nbsp;:&nbsp; </span>  {{ row.ship_location }} </span><br>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.category }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold">{{ row.description }}</span>
                      </td>
                      <td class="align-middle text-left text-sm">
                        <span class="text-secondary text-xs font-weight-bold"><span class="font-weight-bold text-dark">PO DATE &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; </span>  {{ moment(row.po_date).locale('us').format('ll') }} </span><br>
                        <span class="text-secondary text-xs font-weight-bold"><span class="font-weight-bold text-dark">CUST. REQUEST DATE &nbsp;&nbsp;:&nbsp; </span>  {{ moment(row.customer_req_date).locale('us').format('ll') }} </span><br>
                        <span class="text-secondary text-xs font-weight-bold"><span class="font-weight-bold text-dark">DELIVERY DATE &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp; </span>  {{ moment(row.delivery_date).locale('us').format('ll') }} </span><br>
                      </td>
                      <td class="align-middle text-right text-sm">
                        <span class="badge badge-sm bg-gradient-primary" v-if="row.status == 'Active'">Active</span>
                        <span class="badge badge-sm bg-gradient-danger" v-if="row.status == 'Inactive'">Inactive</span>
                      </td>
                      <td class="align-middle text-center">
                        <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="edit(row.id)" title="Edit"></i>
                        <i class="fas fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="remove(row.id)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <div class="float-right">
                <base-pagination :page-count="pagination.page_count" :value="pagination.page" @input="changePage" :total="pagination.page_count" class="justify-content-end"></base-pagination>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- ===================================================  MODAL ADD DATA ======================================= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{form.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Project Number <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Project Number" v-model="projectData.project_number">
        <label for="example-text-input" class="form-control-label mt-3">Project Name <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Project Name" v-model="projectData.project_name">
        <label for="example-text-input" class="form-control-label mt-3">Category <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="projectData.category">
          <option value="Fabrication">Fabrication</option>
          <option value="Service">Service</option>
          <option value="Misc">Misc</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Equipment</label>
        <multiselect v-model="projectData.equipment" :options="tableEquipment.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Equipment" label="quipment_name" track-by="quipment_name" :preselect-first="true" @keyup="getEquipment" :custom-label="nameWithLang">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">Customer </label>
        <multiselect v-model="projectData.customer" :options="tableCustomer.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Customer" label="name" track-by="name" :preselect-first="true" @keyup="getCustomer">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <!-- <label for="example-text-input" class="form-control-label mt-3">Ship Location </label>
        <input type="text" class="form-control" placeholder="Ship Location" v-model="projectData.ship_location"> -->
        <label for="example-text-input" class="form-control-label mt-3">PO Number </label>
        <input type="text" class="form-control" placeholder="PO Number" v-model="projectData.cust_po_number">
        <label for="example-text-input" class="form-control-label mt-3">Description </label>
        <input type="text" class="form-control" placeholder="Description" v-model="projectData.description">
        <label for="example-text-input" class="form-control-label mt-3">PO Date </label>
        <input type="date" class="form-control" placeholder="PO Date" v-model="projectData.po_date">
        <label for="example-text-input" class="form-control-label mt-3">Customer Request Date </label>
        <input type="date" class="form-control" placeholder="Customer Request Date" v-model="projectData.customer_req_date">
        <label for="example-text-input" class="form-control-label mt-3">Delivery Date </label>
        <input type="date" class="form-control" placeholder="Delivery Date" v-model="projectData.delivery_date">
        <label for="example-text-input" class="form-control-label mt-3">Status <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="projectData.status">
          <option selected>Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="form.show = true">Close</argon-button>
        </div>
        <div class="col-1">
          <button type="success" class="btn btn-sm btn-success btn-fill" @click="save()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span>Save </span>
            </span>
          </button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =====================================================  MODAL FILTER ========================================= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">Project Number</label>
        <input type="text" class="form-control" placeholder="Project Number" v-model="search.project_number" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Project Name</label>
        <input type="text" class="form-control" placeholder="Project Name" v-model="search.project_name" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Category </label>
        <select class="form-select" aria-label="Default select example" v-model="search.category" v-on:keyup.enter="get()">
          <option value="Fabrication">Fabrication</option>
          <option value="Service">Service</option>
          <option value="Misc">Misc</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Equipment </label>
        <multiselect v-model="search.equipment" :options="tableEquipment.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Equipment" label="quipment_name" track-by="quipment_name" :preselect-first="true" @keyup="getEquipment" :custom-label="nameWithLang">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">Customer </label>
        <multiselect v-model="search.customer" :options="tableCustomer.data" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Customer" label="name" track-by="name" :preselect-first="true" @keyup="getCustomer">
          <slot name="selection"><slot name="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length" v-show="!isOpen">{{ values.length }} options selected</span></slot></slot>
        </multiselect>
        <label for="example-text-input" class="form-control-label mt-3">PO Number </label>
        <input type="text" class="form-control" placeholder="PO Number" v-model="search.cust_po_number" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Description </label>
        <input type="text" class="form-control" placeholder="Description" v-model="search.description" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">PO Date </label>
        <input type="date" class="form-control" placeholder="PO Date" v-model="search.po_date" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Customer Request Date </label>
        <input type="date" class="form-control" placeholder="Customer Request Date" v-model="search.customer_req_date" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Delivery Date </label>
        <input type="date" class="form-control" placeholder="Delivery Date" v-model="search.delivery_date" v-on:keyup.enter="get()">
        <label for="example-text-input" class="form-control-label mt-3">Status </label>
        <select class="form-select" aria-label="Default select example" v-model="search.status">
          <option selected>Status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="search = {}">Clear</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="get()">Filter</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL IMPORT ======= -->
  <div class="container">
    <vue-final-modal v-model="formImport.show" classes="modal-container" content-class="modal-content" :z-index="10000">
    <!-- header -->
    <div class="row">
      <div class="col-11 float-left">
        <span class="modal__title">{{formImport.title}}</span>
      </div>
      <div class="col-1 float-right">
        <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formImport.show = false"></i>
      </div>
    </div><hr>
    <!-- end header -->
    <div class="modal__content container">
      <div>
        <label for="example-text-input" class="form-control-label mt-3">Upload File <span style="color: red;">*</span></label>
        <input type="file" class="form-control" placeholder="Upload File" @change="filesChange" style="margin-bottom: 20px;">
        <small>Download Template<a :href="storageUrl+'/template_import/Template Import Data Users.xlsx'" style="color: blue;"> Import Data Setting Approval</a></small>
        <div class="mt-2" v-if="tabelError.data.length !== 0 ">
          <table>
            <thead>
              <slot name="columns">
                <tr style="background-color: #F0F8FF;">
                  <th style="font-size: 13px; text-align: center;">Column</th>
                  <th style="font-size: 13px; text-align: center;">Error</th>
                  <th style="font-size: 13px; text-align: center;">Row</th>
                  <th style="font-size: 13px; text-align: center;">Values</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tabelError.data" :key="i">
                <td style="font-size: 13px; text-align: center;">{{ row.attribute }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.errors }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.row }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.values }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="row float-right mt-5">
      <div class="col-6"> 
      </div>
      <div class="col-2" style="margin-right: 20px;">
        <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formImport.show = false">Close</argon-button>
      </div>
      <div class="col-1">
        <button type="primary" class="btn btn-sm btn-info btn-fill" @click="importData()" :disabled="onLoading">
          <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
          <span v-else>
              <span>Import</span>
          </span>
        </button>
        <!-- <argon-button variant="gradient" color="success" size="sm" width="1" @click="get(), formImport.show = false">Import</argon-button> -->
      </div>
    </div>
    <!-- end footer -->
    </vue-final-modal>
  </div>
</template>

<script>
import Card from "@/examples/Cards/Card.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import BasePagination from "@/components/BasePagination";
import Multiselect from 'vue-multiselect'
import Api from '@/helpers/api';
import config from '@/configs/config';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import projectList from '@/services/projectList.service';
import equipment from '@/services/equipment.service';
import customer from '@/services/customer.service';

export default {
  name: "tables",
  components: {
    Card,
    ArgonButton,
    VueFinalModal,
    Multiselect,
    BasePagination,
  },
  data() {
    return {
      pagination: {
        page_count: '',
        page: 1,
      },
      moment:moment,
      table: {
        data: []
      },
      form: {
        add: true,
        title: "Add Data",
        show: false
      },
      formImport: {
        add: true,
        title: "Import Data Setting Approval",
        show: false
      },
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      dataImport: '',
      onLoading: false,
      tabelError: {
        data: []
      },
      tableEquipment: {
        data: []
      },
      tableCustomer: {
        data: []
      },
      storageUrl : config.storageUrl,
      projectData: {},
      search: {
        project_number: '',
        project_name: '',
        category: '',
        equipment: '',
        customer: '',
        cust_po_number: '',
        po_date: '',
        customer_req_date: '',
        delivery_date: '',
        status: '',
      },
      searchMenu: '',
      apiUrl :config.apiUrl,

      totalFabProject: '',
      totalServcProject: '',
      totalActiveProject: '',
      totalInactiveProject: '',

    };
  },
  mounted(){
    this.get();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
  },
  methods: {
    nameWithLang ({ equipment_number, equipment_name }) {
      return `${equipment_number} - ${equipment_name}`
    },
    get(param){
      let context = this;               
      Api(context, projectList.index({project_number: this.search.project_number, project_name: this.search.project_name, category: this.search.category, customer: this.search.customer['name'], equipment: this.search.equipment['equipment_number'], cust_po_number: this.search.cust_po_number, po_date: this.search.po_date, customer_req_date: this.search.customer_req_date, delivery_date: this.search.delivery_date, status: this.search.status, page: context.pagination.page})).onSuccess(function(response) {    
          context.table.data            = response.data.data.data.data;
          context.pagination.page_count = response.data.data.data.last_page

          context.totalFabProject      = response.data.data.totalFabProject;
          context.totalServcProject    = response.data.data.totalServcProject;
          context.totalActiveProject   = response.data.data.totalActiveProject;
          context.totalInactiveProject = response.data.data.totalInactiveProject;
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.formFilter.show  = false;
      })
      .call()
    },
    getEquipment(param){
      let context = this;        
      Api(context, equipment.getEquipment({search: param.target.value})).onSuccess(function(response) {    
          context.tableEquipment.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableEquipment.data = [];
          }
      }).onFinish(function() { 
      })
      .call()
    },
    getCustomer(param){
      let context = this;        
      Api(context, customer.getCustomer({search: param.target.value})).onSuccess(function(response) {    
          context.tableCustomer.data = response.data.data;
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableCustomer.data = [];
          }
      }).onFinish(function() { 
      })
      .call()
    },

    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.pagination.page  = 1 ;
    },
    create() {
      this.form.add   = true;
      this.form.show  = true;
      this.form.title = "Add Data";
      this.projectData   = {};
    },
    edit(id) {
      let context = this;               
      Api(context, projectList.show(id)).onSuccess(function(response) {
          context.projectData           = response.data.data.data;
          context.projectData.equipment = response.data.data.dataEquip
          context.projectData.customer  = response.data.data.dataCost
          context.form.show             = true;
          context.form.title            = 'Edit Data';   
      })
      .call()        
    },
    save(){
      let api      = null;
      let context  = this;
      let formData = new FormData();
      context.onLoading = true;

      if (context.projectData.project_number != undefined && context.projectData.project_name != undefined && context.projectData.category != undefined && context.projectData.status != undefined) {
        formData.append('project_number', context.projectData.project_number);
        formData.append('project_name', context.projectData.project_name);
        formData.append('category', context.projectData.category);
        formData.append('equipment', (JSON.stringify(context.projectData.equipment) == undefined) ? '' :  JSON.stringify(context.projectData.equipment));
        formData.append('customer', (JSON.stringify(context.projectData.customer) == undefined) ? '' :  JSON.stringify(context.projectData.customer));
        formData.append('cust_po_number', (context.projectData.cust_po_number == undefined) ? '' : context.projectData.cust_po_number);
        formData.append('description', (context.projectData.description == undefined) ? '' : context.projectData.description);
        formData.append('po_date', (context.projectData.po_date == undefined) ? '' : context.projectData.po_date);
        formData.append('customer_req_date', (context.projectData.customer_req_date == undefined) ? '' : context.projectData.customer_req_date);
        formData.append('delivery_date', (context.projectData.delivery_date == undefined) ? '' : context.projectData.delivery_date);
        formData.append('status', context.projectData.status);
      }else{
        context.onLoading = false;
        return alert('The Red Star Field is Mandatory')
      }

      if (context.form.title == 'Add Data') {
          api = Api(context, projectList.create(formData));
      } else {
          api = Api(context, projectList.update(this.projectData.id, formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.get();
        context.form.show = false;
        context.notify((context.form === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.form != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
        context.onLoading = false;
      })
      .call();
    },
    remove(id) {
      var r = confirm("Are you sure you want to delete this data ?");
      if (r == true) {
        let context = this;

        Api(context, projectList.delete(id)).onSuccess(function(response) {
            context.get();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    modalImport(){
      this.formImport.show  = true;
      this.formImport.title = "Import Data Setting Approval";
      this.tabelError.data  = [];
    },
    filesChange(e) {
        this.dataImport = e.target.files[0];
    },
    importData(){
      let api = null;
      let context = this;
      let formData = new FormData();
      this.onLoading = true;

      if (this.dataImport != undefined) {
        formData.append('import_data', this.dataImport);
      }else{
        return alert('File Import Not Found')
      }

      api = Api(context, projectList.import(formData));
      api.onSuccess(function(response) {
          context.onLoading = false;
          context.get();
          context.formImport.show = false;
          context.notify('Import Data Success', 'success')
      }).onError(function(error) {      
          context.tabelError.data = error.response.data.data;              
          context.notify('Import Data Failed', 'error')
          context.onLoading = false;
      }).onFinish(function() {  
      })
      .call();
    },
    changePage(page){
      this.pagination.page = page;
      this.get();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          autoClose: 2000,
        }); // ToastOptions
      }
    },

  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 600px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED;
  padding-top: 10px;
  padding-bottom: 10px;
}

tr:hover {background-color: #D3D3D3;}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

</style>
